import React, { useState, useEffect } from 'react';
import { useTheme } from '@mui/material/styles';
import { Grid, Typography, Paper, Table, TableHead, TableBody, TableRow, TableCell } from '@mui/material';
import { gridSpacing } from 'utils/constants';
import MainCard from 'components/Cards/MainCard';
import ApiHelper from 'utils/apiHelper';
import { toast } from 'react-toastify';
import ReportFileExports from 'components/Reports/FileExports';

const ReportsGroupSummary = () => {
    const theme = useTheme();
    const [loading, setLoading] = useState(false);
    const [groupSummaryData, setGroupSummaryData] = useState([]);

    useEffect(() => {
        getGroupSummaryData();
    }, []);

    const getGroupSummaryData = () => {
        setLoading(true);
        ApiHelper.get('/api/reports/group_summary/')
            .then((res) => {
                setGroupSummaryData(res.data);
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
                toast.warning('There is no group summary data');
            });
    };

    return (
        <MainCard title="Operational Reports Management" cardHeaderTitle="Group Summary" cardHeaderShow={true}>
            <Grid container spacing={gridSpacing}>
                <Grid item xs={10}>
                    <Typography sx={{ fontSize: '16px' }}>Lists the groups in use and the number of devices in each group</Typography>
                </Grid>
                {groupSummaryData.length > 0 && (
                    <Grid item xs={2}>
                        <ReportFileExports
                            elementId="groupSummary"
                            reportTitle="Group Summary"
                            downloadFileName="group_summary"
                            downloadFileOption="all"
                            data={groupSummaryData}
                            headers={[
                                { label: 'Devices in Group', key: 'devices_in_group' },
                                { label: 'Group Name', key: 'group_name' },
                                { label: 'Group Description', key: 'group_description' }
                            ]}
                            filtersData={[]}
                        />
                    </Grid>
                )}
                <Grid item xs={12}>
                    <Paper sx={{ overflowX: 'hidden' }} id="groupSummary">
                        {loading === true ? (
                            <Typography sx={{ mt: 3, textAlign: 'center', fontSize: '16px', fontWeight: 'bold' }}>
                                Please wait...
                            </Typography>
                        ) : groupSummaryData.length === 0 ? (
                            <Typography sx={{ textAlign: 'center', mt: 3 }} color={theme.palette.secondary.main}>
                                No data for the group summary report
                            </Typography>
                        ) : (
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Devices in Group</TableCell>
                                        <TableCell>Group Name</TableCell>
                                        <TableCell>Group Description</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {groupSummaryData.map((data, key) => (
                                        <TableRow key={key}>
                                            <TableCell>{data.devices_in_group}</TableCell>
                                            <TableCell>{data.group_name}</TableCell>
                                            <TableCell>{data.group_description}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        )}
                    </Paper>
                </Grid>
            </Grid>
        </MainCard>
    );
};

export default ReportsGroupSummary;
